import { render, staticRenderFns } from "./greaterThan.vue?vue&type=template&id=43d25fa9&"
import script from "./greaterThan.vue?vue&type=script&lang=ts&"
export * from "./greaterThan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports